import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../shared/services/logging/logging.service';
import { CategoriesService } from '../shared/category/categories.service';
import { processResolver } from './process-resolver';
import { ExpenseItemFeatureComponent } from '../expense-item/feature/expense-item-feature.component';


const log = new LoggingService();
export const ExpenseItemRoute: Ng2StateDeclaration = {
    name: 'expenseitems',
    url: '/expenseitems',
    data: { requiresAuth: true },
    params: { process: {} },
    resolve: [
        {
            token: 'process',
            deps: [Transition, CategoriesService],
            resolveFn: processResolver
        }
    ],
    component: ExpenseItemFeatureComponent
};
